import "./InputComponent.scss";
import {useCallback} from "react";
import {IInputFieldProps} from "../../../models/form-controls.model";
import {CommonService} from "../../../services";
import ErrorTextComponent from "../../error-text/ErrorTextComponent";
import LabelComponent from "../../label/LabelComponent";

export interface InputComponentProps extends IInputFieldProps {
    name?: string;
    value?: string;
    errorMessage?: any;
    hasError?: boolean;
    maxlength?: number;
    endIcon?: any;
    style?: React.CSSProperties;
}

const InputComponent = (props: InputComponentProps) => {

    const {
        style,
        label,
        titleCase,
        errorMessage,
        hasError,
        className,
        inputProps,
        disabled,
        required,
        value,
        validationPattern,
        fullWidth,
        size,
        maxlength,
        onChange,
        ...otherProps
    } = props;

    const inputSize = props.size || "medium";
    const type = props.type || "text";
    const placeholder = props.placeholder || label;

    const handleOnChange = useCallback((event: any) => {
        let nextValue = event.target.value;
        if (titleCase) {
            nextValue = CommonService.Capitalize(nextValue);
        }
        if (onChange) {
            if (validationPattern) {
                const reg = RegExp(validationPattern);
                if (nextValue === "" || reg.test(nextValue)) {
                    onChange(nextValue);
                } else {
                    // console.log(nextValue, reg, reg.test(nextValue), "regex failed");
                }
            } else {
                onChange(nextValue);
            }
        }
    }, [titleCase, validationPattern, onChange]);

    return (
        <div className={`input-component ${fullWidth ? "fullWidth" : ''} ${disabled ? 'disabled' : ''}`}>
            {label && <LabelComponent title={label} required={required}/>}
            <div className="input-wrapper">
                <input type={type}
                       style={style}
                       maxLength={maxlength}
                       placeholder={placeholder}
                       required={required}
                       value={value || ""}
                       disabled={disabled}
                       className={'input-field ' + (hasError ? "has-error" : '') + ' ' + className + ' ' + inputSize}
                       onChange={(event) => {
                           handleOnChange(event);
                       }}

                       {...inputProps}
                       {...otherProps}
                />
                {props.endIcon && (
                    <div className="end-icon">
                        {props.endIcon}
                    </div>
                )}
            </div>
            {(errorMessage && hasError) && (
                <ErrorTextComponent error={errorMessage}/>
            )}
        </div>
    );

};

export default InputComponent;
